// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-plus-corner.js';

import { paths } from '../generated/file-plus-corner';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-plus-corner', Original, paths);
